import { Children, cloneElement } from "react";
import PropTypes from "prop-types";
import { Navigate, useLocation } from "react-router-dom";
import { isAuthenticated } from "app/pages/Auth/authSelectors";
import { connect } from "react-redux";

const BookingPrivateRoute = ({ authPath, isAuthenticated, children }) => {
	const { pathname, search } = useLocation();

	const onauthsuccessUrl = encodeURIComponent(`${pathname}${search}`);

	const childrenWithProps = Children.map(children, child => {
		return cloneElement(child);
	});
	// TODO ROUTER isAuthenticated renvoie toujours false en SSR
	return isAuthenticated ? (
		childrenWithProps
	) : (
		<Navigate
			replace
			to={{
				pathname: authPath,
				search: `?onauthsuccess=${onauthsuccessUrl}`,
			}}
		/>
	);
};

BookingPrivateRoute.propTypes = {
	isAuthenticated: PropTypes.bool.isRequired,
	authPath: PropTypes.string,
};

const mapStateToProps = state => {
	return { isAuthenticated: isAuthenticated(state) };
};

export default connect(mapStateToProps)(BookingPrivateRoute);
